import React, { FunctionComponent } from 'react';
import { Text } from 'components/chroma';
import {
  premiumExcessDiscountUrl,
  productDisclosureStatementUrl,
} from 'scenes/common/helpers/contacts';

const ExcessDisclaimer: FunctionComponent<{ isThirdParty?: boolean }> = ({
  isThirdParty,
}) => (
  <>
    <Text>
      Other excesses may apply as set out in the Premium, Excess and Discounts (
      <a
        href={premiumExcessDiscountUrl()}
        target="_blank"
        rel="noopener noreferrer"
      >
        PED
      </a>
      ) Guide.
    </Text>
    {!isThirdParty && (
      <Text>
        Please carefully consider your excess choice as it may exceed some
        policy limits. This may affect your ability to claim on these benefits.
        Please refer to our{' '}
        <a
          href={productDisclosureStatementUrl()}
          target="_blank"
          rel="noopener noreferrer"
        >
          PDS
        </a>{' '}
        for all policy limits.
      </Text>
    )}
  </>
);

export default ExcessDisclaimer;
